import {
  PROPOSE_TASK_CREATE, PROPOSE_TASK_CREATE_FAILURE, PROPOSE_TASK_CREATE_SUCCESS
} from './mutation-types'

export default {
  state: {},
  getters: {},
  actions: {
    [PROPOSE_TASK_CREATE] ({dispatch, state, commit}, params) {
      const url = '/master/propose_tasks/'
      let data = {}
      let callback = null
      data = params.data
      params.callback && (callback = params.callback)
      dispatch('apiPost', {url: url, data: data, callback: callback})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_TASK_CREATE_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(PROPOSE_TASK_CREATE_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [PROPOSE_TASK_CREATE_FAILURE] (state, data) {
      console.log('PROPOSE_TASK_CREATE_FAILURE')
    },
    [PROPOSE_TASK_CREATE_SUCCESS] (state, data) {
      console.log('PROPOSE_TASK_CREATE_SUCCESS')
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/propose-task-new.js